define(
    'viewmodels/secured/header',[
        "viewmodels/secured/explorer/context",
        "providers/dataprovider",
        "viewmodels/ViewModel",
        "i19n!i19n/strings",
        "plugins/router",
        "services/config",
        "services/service.dialog",

        "extensions/knockout/fp_toggles_visible",
        "extensions/knockout/binding_class"
    ],
    function (ctx, dataProvider, ViewModel, i19n, router, config, dialogService) {
        var vm = new ViewModel({
            i19n: i19n,

            togglesVisible: ko.observable(true),
            hotspot: {
                navigation: ko.observable('fa-toggle-left'),
                details: ko.observable('fa-toggle-right')
            },
            isAddDocument: ko.observable(false),

            isGuest: ko.observable(false),
            isUser: ko.observable(false),
            isAdmin: ko.observable(false),
            isInstanceAdmin: ko.observable(false),
            isShowSetup: ko.observable(false),
            userAvatarText: ko.observable(""),
            isSuspended: ko.observable(true)
        });

        vm.eventBroker.on(vm, vm.config.events.header.show, function (data) {
            vm.isSuspended(!data.isShow);
        });

        router.activeItem().router.on("router:navigation:complete", function (instance, instruction, router) {
            vm.togglesVisible(instruction.config.settings && instruction.config.settings.showToggles);
        });

        var subscription = vm.eventBroker.on(vm, vm.config.events.explorer.layout.resizedDetailsPane, function () {
            updateVisibles();
            subscription.off();
        });

        ctx.onNavSearch.subscribe(function (data) {
            vm.isAddDocument(false);
        });
        ctx.onNavFavoriteFolder.subscribe(function (folder) {
            vm.isAddDocument(false);
        });
        ctx.onNavFavoriteSearch.subscribe(function (folder) {
            vm.isAddDocument(false);
        });
        ctx.onNavFavoriteDocument.subscribe(function (data) {
            vm.isAddDocument(false);
        });
        ctx.onNavFlagged.subscribe(function (data) {
            vm.isAddDocument(false);
        });
        ctx.onNavRecent.subscribe(function (data) {
            vm.isAddDocument(false);
        });
        ctx.onNavMyCheckedOut.subscribe(function (data) {
            vm.isAddDocument(false);
        });
        ctx.onNavAllCheckedOut.subscribe(function (data) {
            vm.isAddDocument(false);
        });
        ctx.onNavFolder.subscribe(function (data) {
            var folder = !data ? null : data.folder;

            vm.isAddDocument(folder);
        });
        ctx.onNavMyDeleted.subscribe(function (data) {
            vm.isAddDocument(false);
        });
        ctx.onNavAllDeleted.subscribe(function (data) {
            vm.isAddDocument(false);
        });

        vm.activate = function () {
            vm.isGuest(vm.session.role == 0 || vm.session.role == 1 ? true : false);
            vm.isUser(vm.session.role == 2);
            vm.isAdmin(vm.session.role == 3);
            vm.isInstanceAdmin(vm.session.role == 4);

            //vm.isShowSetup((vm.session.user().emailAddress().indexOf('@radix.com.au') != -1) || (vm.session.user().emailAddress().indexOf('rollie') != -1));
            vm.isShowSetup(true);
            vm.userAvatarText(vm.session.user().firstName() + (vm.session.user().lastName().length > 0 ? vm.session.user().lastName().substring(0, 1) : ""));

            if (sessionStorage.getItem("__hasLogin") === "1") {
                sessionStorage.setItem("__hasLogin", "0");
                if (!vm.session.settingsGuided().IsDontShowMeAgainNextLogin() && vm.isInstanceAdmin() && vm.isShowSetup()) {
                    dialogService.showDialog("modals/secured/help/SetupGuideModal")
                    .then(function (dialogResult) { });
                }                
            }

            return vm.session.getIsSuspended()
            .done(function (isSuspended) {
                vm.isSuspended(isSuspended);
            })
            .fail(function (e) {
                console.error(e);
            });                        
        };
        vm.toggleNavigation = function () {
            vm.eventBroker.trigger(vm, vm.config.events.explorer.layout.toggleNavigation, vm);

            updateVisibles();
        };
        vm.toggleDetails = function () {
            vm.eventBroker.trigger(vm, vm.config.events.explorer.layout.toggleDetails, vm);

            updateVisibles();
        };
        vm.libraries = function () {
            router.navigate("libraries");
        };
        vm.lists = function () {
            router.navigate("lists");
        };
        vm.people = function () {
            router.navigate("people");
        };
        vm.explore = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;

                //window.history.pushState('', 'Explorer | fileplan', sessionStorage.__url);
                //window.location.reload();
            } else {
                router.navigate("explorer");
            }
            
        };
        vm.mySharesClick = function () {
            router.navigate("shares/my");
        };        
        vm.myUploadRequest = function () {
            router.navigate("uploads/my");
        };
        
        vm.settings = function () {
            router.navigate("settings");
        };
        vm.changePasswordClick = function () {
            router.navigate("change");
        };
        vm.changeSubscriptionClick = function () {

            dataProvider.subscription
            .getCustomerSubs()
            .done(function (subs) {
                var isCustomerTrial = vm.session.isCustomerTrial == -1 ? true : vm.session.isCustomerTrial;
                var isOldClient = subs.subsPlanCode == "fileplan_starter_aud" && !isCustomerTrial;
                
                if (isOldClient)
                    router.navigate("#plan/1");
                else
                    router.navigate("#pricing/1");
            })
            .fail(function (e) {
                console.error(e);

                e.stopPropagation = true;                
            });
        };
        vm.manageAccountClick = function () {
            dataProvider.subscription
            .getOrCreateSessionPortal({ redirectUrl: 'www.fileplanapp.com', instanceId: window.fileplan.instanceCode })
            .done(function (data) {
                //$('a#___subscriptionlink')[0].setAttribute('href', data.accessUrl);
                //$('a#___subscriptionlink')[0].click();

                window.location.replace(data.accessUrl);
            })
            .fail(function (e) {
                console.error(e);

                //e.stopPropagation = true;
            });
        };
        vm.logout = function () {
            router.navigate("#logout");
        };        
        vm.addDocumentFromTemplate = function () {
            if (vm.isAddDocument() && ctx.current.folder) {
                var folderId = ctx.current.folder.folderId;
                var permitted = 0;

                dataProvider.accessControl
                .folders
                .getAllowedActions(folderId)
                .done(function (permissions) {
                    permitted = (permissions & 8);

                    if (permitted > 0) {
                        router.navigate("#actionsAddTemplate");
                    } else {
                        //dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionAddErrorModal", '');
                        toastr.error("Folder write permission denied", "Denied");
                    }
                });
            } else {
                dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionAddErrorModal", '');
            }
        };
        vm.addDocumentFromComputer = function () {
            if (vm.isAddDocument() && ctx.current.folder) {
                var folderId = ctx.current.folder.folderId;
                var permitted = 0;

                dataProvider.accessControl
                .folders
                .getAllowedActions(folderId)
                .done(function (permissions) {
                    permitted = (permissions & 8);

                    if (permitted > 0) {
                        router.navigate("#actionsAddDocument");
                    } else {
                        //dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionAddErrorModal", '');
                        toastr.error("Folder write permission denied", "Denied");
                    }
                });
            } else {
                dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionAddErrorModal", '');
            }
        };
        vm.sendUploadRequest = function () {
            if (vm.isAddDocument() && ctx.current.folder) {
                var folderId = ctx.current.folder.folderId;
                var permitted = 0;

                dataProvider.accessControl
                .folders
                .getAllowedActions(folderId)
                .done(function (permissions) {
                    permitted = (permissions & 8);

                    if (permitted > 0) {
                        router.navigate("#actionsUploadRequest");
                    } else {
                        //dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionAddErrorModal", '');
                        toastr.error("Folder write permission denied", "Denied");
                    }
                });
            } else {
                dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionAddErrorModal", '');
            }
        };
        vm.helpMe = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                window.open('http://help.fileplan.com');
                complete();
            }
        });
        vm.setupGuide = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                dialogService.showDialog("modals/secured/help/SetupGuideModal")
                .then(function (dialogResult) {
                    complete();
                });
            }
        });

        vm.switchView = function () {
            var instanceCode = config.instanceCode ? config.instanceCode : window.location.hostname.split('.')[0];
            var baseUrl = window.location.hostname.replace(instanceCode + ".", "");

            window.location.href = window.location.protocol + "//mobile." + baseUrl + "/" + instanceCode + "/#explorer";

            return false;
        };

        return vm;

        function updateVisibles() {
            _.defer(function () {
                vm.hotspot.navigation(window.fp.explorerLayout.state.west.isClosed ? 'fa-toggle-right' : 'fa-toggle-left');
                vm.hotspot.details(window.fp.explorerLayout.state.east.isClosed ? 'fa-toggle-left' : 'fa-toggle-right');
            });
        }
    }
);

